import {Component} from '../../../component';

export default class PDFComponent extends Component {
    constructor(args) {
        super(args);
        this.pdf = args;
    }
}
